import { KbColor } from '@kb3d/models/classes/primitives/kb-color';
import { KbVector } from '@kb3d/models/classes/primitives/kb-vector';
import { NodeReference } from '../decorators/change-tracker';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOfAny } from '../decorators/model-utils';
import { eAnnotationLineStyle, eTextureHorizontalAlign, eTextureVerticalAlign } from '../enums';
import { Connector } from '../features/connector';
import { IAnnotationNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';

@Kb3dModel<AnnotationNode>({
    token: Token.AnnotationNode,
})
export class AnnotationNode extends Kb3dObject implements IAnnotationNode {
    public constructor() {
        super();
    }

    isPickable: boolean;
    enabled: boolean;
    billboard: boolean;
    scaleTextWithCamera: boolean;
    color: KbColor;
    fontFamily: string;
    fontSize: number;
    keepOnTop: boolean;
    offset: KbVector;
    lineStyle: eAnnotationLineStyle;
    lineSpacing: number;
    horizontalTextAlign: eTextureHorizontalAlign;
    horizontalBoxAlign: eTextureHorizontalAlign;
    verticalBoxAlign: eTextureVerticalAlign;
    label = '';
    preloadFontStylesheet = '';

    @NodeReference(Connector, 'position', 'direction', 'angle')
    targetId?: string;
}

export function isAnnotation(node: Kb3dObject): node is AnnotationNode {
    return instanceOfAny(node, Token.AnnotationNode, Token.DimensionNode);
}
